export default __webpack_public_path__ + "media/src/assets/images/link-1b0440572f8735fe4b9926a294165bdc.png";